export { OrbitStoreWeb as default } from "./orbitStoreWeb.js";
//# sourceMappingURL=index.js.map